// ============================================================
// Leave Types API
// ============================================================

import client from './axios';

export const leaveTypesApi = {
  getAll: async (schoolId, params = {}) => {
    const response = await client.get('/leave-types/', {
      params: { school_id: schoolId, page: 1, page_size: 100, ...params },
    });
    return response.data;
  },

  getById: async (id, schoolId) => {
    const response = await client.get(`/leave-types/${id}`, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  create: async (schoolId, payload) => {
    const response = await client.post(`/leave-types/?school_id=${schoolId}`, payload);
    return response.data;
  },

  update: async (id, schoolId, payload) => {
    const response = await client.put(`/leave-types/${id}?school_id=${schoolId}`, payload);
    return response.data;
  },

  delete: async (id, schoolId) => {
    const response = await client.delete(`/leave-types/${id}?school_id=${schoolId}`);
    return response.data;
  },
};
